/**
 * Shared job level types for API contracts between frontend and backend
 */
import { z } from "zod";
import { TagResponseSchema } from "./tag.js";
// ============================================================================
// Zod Schemas
// ============================================================================
// Input schemas
export const CreateJobLevelInputSchema = z.object({
    name: z.string().min(1).max(50), // JobLevel.name has VarChar(50) in Prisma
    sortOrder: z.number().int().nonnegative(),
    isDefault: z.boolean().optional(),
});
export const UpdateJobLevelInputSchema = z.object({
    name: z.string().min(1).max(50).optional(),
    sortOrder: z.number().int().nonnegative().optional(),
});
export const ReorderLevelItemSchema = z.object({
    id: z.uuid(),
    sortOrder: z.number().int().nonnegative(),
});
export const ReorderJobLevelsInputSchema = z.object({
    levels: z.array(ReorderLevelItemSchema),
});
// Response schemas
export const JobLevelResponseSchema = z.object({
    id: z.uuid(),
    createdAt: z.iso.datetime(), // ISO string format (service transforms Date to ISO string)
    updatedAt: z.iso.datetime(),
    name: z.string(),
    sortOrder: z.number(),
    isDefault: z.boolean(),
    companyId: z.uuid(),
    tags: z.array(TagResponseSchema).optional(), // Optional for backward compatibility
});
// Org chart schemas
export const OrgChartFamilySchema = z.object({
    id: z.uuid(),
    name: z.string(),
    color: z.string(),
});
export const OrgChartRoleSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    jobLevelId: z.uuid(),
    jobRoleFamilyId: z.uuid(),
});
export const OrgChartDataSchema = z.object({
    levels: z.array(JobLevelResponseSchema),
    families: z.array(OrgChartFamilySchema),
    roles: z.array(OrgChartRoleSchema),
});
